import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="bg-white text-stone-600 py-12 lg:py-20 px-6 lg:px-12 border-t border-stone-200">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-16 mb-12 lg:mb-20">
          <div>
            <img
              src="/images/logo.jpg"
              alt="SPIN MOVE"
              loading="lazy"
              decoding="async"
              className="h-12 lg:h-16 mb-6 lg:mb-8 object-contain"
            />
            <p className="text-sm font-light leading-loose tracking-wide">
              株式会社スピンムーヴ<br />
              総合不動産コンサルティング
            </p>
          </div>

          <div>
            <h4 className="text-sm font-light tracking-wider text-stone-800 mb-4 lg:mb-6">SERVICES</h4>
            <ul className="space-y-3 lg:space-y-4 text-sm font-light">
              <li><Link to="/services" className="link-line hover:text-amber-700 transition-colors">売買・賃貸仲介</Link></li>
              <li><Link to="/renovation" className="link-line hover:text-amber-700 transition-colors">買取・再販</Link></li>
              <li><Link to="/inheritance" className="link-line hover:text-amber-700 transition-colors">相続相談</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-light tracking-wider text-stone-800 mb-4 lg:mb-6">COMPANY</h4>
            <ul className="space-y-3 lg:space-y-4 text-sm font-light">
              <li><Link to="/company" className="link-line hover:text-amber-700 transition-colors">会社概要</Link></li>
              <li><Link to="/contact" className="link-line hover:text-amber-700 transition-colors">お問い合わせ</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-200 bg-stone-700 -mx-6 lg:-mx-12 px-6 lg:px-12 py-6 flex justify-end">
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="group flex items-center gap-2 text-sm font-light tracking-wide text-stone-300 hover:text-amber-400 transition-colors"
          >
            <span>Page Top</span>
            <i className="ri-arrow-up-line transition-transform duration-300 ease-out-expo group-hover:-translate-y-1"></i>
          </button>
        </div>
      </div>
    </footer>
  );
}
